<template>
    <section class="container-fluid my-4">
        <h4 class="my-4">Diário de <strong>classe</strong></h4>

        <form @submit.prevent="generateClassDiary">

            <div class="row">

                <div class="form-group col-md-6">

                    <div class="mb-3">
                        <SearchableSelect
                            v-model="team_id"
                            :options="teams"
                            item-text="name"
                            item-value="id"
                            label="Turma"
                            placeholder="-- Selecione uma turma --"
                        />
                    </div>

                    <div class="mb-3">
                        <label class="form-label">Status dos Alunos <small class="text-secondary">(por padrão, quando vazio: Ativo, Concluído)</small></label>
                        <MultiSelect
                            v-model="studentStatus"
                            :options="statusOptions"
                        />
                    </div>

                    <div v-if="!loading" class="form-group text-center my-2">
                        <button type="submit" class="btn btn-success btn-sm mx-2 text-uppercase">
                            Gerar
                        </button>
                        <button type="reset" class="btn btn-secondary btn-sm text-uppercase" @click="clearForm">
                            Limpar
                        </button>
                    </div>
                    <LoadingPage v-else />

                </div>

            </div>

        </form>

        <button class="btn btn-sm btn-secondary" @click="$router.go(-1)">
            VOLTAR
        </button>
    </section>
</template>

<script>
import api from "@/services";
import LoadingPage from "@/components/LoadingPage.vue";
import SearchableSelect from "@/components/SearchableSelect.vue";
import MultiSelect from "@/components/MultiSelect.vue";
import { handleBlobError, studentStatusOptions } from "@/helpers";

export default {
    name: "DiarioDeClasse",
    components: {
        LoadingPage,
        SearchableSelect,
        MultiSelect,
    },
    data() {
        return {
            team_id: "",
            studentStatus: [],
            teams: [],
            loading: false,
            statusOptions: studentStatusOptions,
        };
    },
    methods: {
        async getTeams() {
            await api.get(`/teams?page=0&perPage=99999&sortBy=name&forPagination=1`).then((res) => {
                this.teams = res.data.data;
            });
        },
        clearForm() {
            this.team_id = "";
            this.studentStatus = [];
        },
        async generateClassDiary() {

            if (!this.team_id)
                return Toast.fire('Erro', 'Por favor, selecione uma turma.', "error");

            try {

                this.loading = !this.loading;

                const teamName = this.teams.filter((e) => e.id == this.team_id);

                const params = new URLSearchParams({
                    team_id: this.team_id
                });
                
                // Adiciona os status selecionados aos parâmetros
                this.studentStatus.forEach(status => {
                    params.append('student_status[]', status);
                });

                await api
                    .get(`/exports/class-diary?${params.toString()}`, {
                        responseType: "blob",
                    })
                    .then((response) => {

                        const blob = new Blob(
                            [response.data],
                            { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," }
                        );

                        const a = document.createElement("a");
                        a.href = URL.createObjectURL(blob);
                        a.download = `DiarioDeClasse - ` + teamName[0].name.toUpperCase();
                        a.click();

                    });

            } catch (error) {
                handleBlobError(error, (message) => {
                    Toast.fire('Erro', message, "error");
                });
            }
            this.loading = !this.loading;

        },
    },
    mounted() {
        this.getTeams();
    },
};
</script>

<style scoped></style>